import React from 'react'
import { Select } from '@chakra-ui/react'

const TYPES = [
  {
    id: 'BINARY',
    label: 'Binária'
  },
  {
    id: 'LIKERT3',
    label: 'Likert 3'
  },
  {
    id: 'LIKERT5',
    label: 'Likert 5'
  },
  {
    id: 'LIKERT7',
    label: 'Likert 7'
  },
  {
    id: 'MULTIPLE',
    label: 'Múltipla escolha'
  }
]

export const QuestionTypeSelect = React.forwardRef(
  ({ placeholder = 'Escolha uma opção', ...props }, ref) => (
    <Select {...props} ref={ref} placeholder={placeholder}>
      {TYPES.map(({ id, label }) => (
        <option value={id} key={id}>
          {label}
        </option>
      ))}
    </Select>
  )
)

export default QuestionTypeSelect
